import React, { useState, useRef, useEffect } from "react";
import Profile from "../Pages/Profie";
import Login from "./../Pages/Login";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { API } from "./../../config/api";
import "./../Styles/Navbar.css";
import "./../Styles/contact.css";
import "./../Styles/Home.css";
import "./../Styles/footer.css";
import "./../Styles/machines.css";
import "./../Styles/ProductDetails.css";
import "./../Styles/house.css";
import "./../Styles/designer.css";
import "./../Styles/wishlist.css";
import "./../Styles/login.css";
import "./../Styles/about.css";
import "./../Styles/ragister.css";
import "./../Styles/HouseRentDetails.css";
import "./../Styles/designerdetails.css";
import "./../Styles/theme.css";

export default function Navbar() {
  const [supplierTypes, setSupplierTypes] = useState([]);
  const location = useLocation();

  const [showprofile, setShowprofile] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const dropdownRef = useRef();
  const [showStickyNav, setShowStickyNav] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [bidCount, setBidCount] = useState(0);
  const lastScroll = useRef(0);
  // Inside Navbar.jsx logic...

  const [counts, setCounts] = useState({ wishlist: 0, cart: 0, orders: 0 });

  const updateLocalCounts = () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (loginUser) {
      // 1. Get raw data from localStorage
      const localCart =
        JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
      const localWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      // 2. Update state with the lengths
      setCounts((prev) => ({
        ...prev,
        cart: localCart.length,
        wishlist: localWishlist.length,
      }));

      // 3. Fetch orders from Database
      fetchOrdersCount(loginUser.id);
    } else {
      // Reset counts if no user is logged in
      setCounts({ wishlist: 0, cart: 0, orders: 0 });
    }
  };

  const fetchOrdersCount = async (userId) => {
    try {
      const res = await fetch(` ${API.COUNTS1}&user_id=${userId}`);
      const data = await res.json();
      setCounts((prev) => ({ ...prev, orders: data.orders_count || 0 }));
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    fetch(`${API.BASE_URL}/api.php?action=supplier_types`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSupplierTypes(data.data);
        }
      });
  }, []);
  useEffect(() => {
    const shouldOpen = sessionStorage.getItem("openLoginPopup");

    if (shouldOpen === "true") {
      setShowLogin(true);
      sessionStorage.removeItem("openLoginPopup");
    }
  }, [location.pathname]);
  useEffect(() => {
    updateLocalCounts();

    // This must match the name in dispatchEvent
    window.addEventListener("cartUpdated", updateLocalCounts);
    window.addEventListener("userLogin", updateLocalCounts);

    return () => {
      window.removeEventListener("cartUpdated", updateLocalCounts);
      window.removeEventListener("userLogin", updateLocalCounts);
    };
  }, []);

  useEffect(() => {
    if (location.state?.openLogin) {
      setShowLogin(true);

      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, [location]);
  const fetchBidCount = async (userId) => {
    try {
      const res = await fetch(
        `${API.BASE_URL}/api.php?action=get_my_bid_count&designer_id=${userId}`,
      );

      const data = await res.json();

      if (data.status) {
        setBidCount(data.count);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const current = window.pageYOffset;

  //     // Navbar becomes sticky after top header
  //     setShowStickyNav(current > 120);

  //     if (current > lastScroll.current && current > 180) {
  //       // scrolling down
  //       setHideNav(true);
  //     } else {
  //       // scrolling up
  //       setHideNav(false);
  //     }

  //     lastScroll.current = current;
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      const current = window.pageYOffset;

      // Sticky Navbar
      setShowStickyNav(current > 120);

      // Show Scroll Top Button after 400px
      setShowScrollTop(current > 400);

      // Hide Navbar while scrolling down
      if (current > lastScroll.current && current > 180) {
        setHideNav(true);
      } else {
        setHideNav(false);
      }

      lastScroll.current = current;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  /* ================= LOAD USER ================= */
  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));

      setUser(loginUser);

      if (loginUser) {
        fetchBidCount(loginUser.id);
      } else {
        setBidCount(0);
      }
    };

    loadUser();

    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);
  /* ================= CLICK OUTSIDE ================= */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* ================= LOGOUT ================= */
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem("user");

    setUser(null);

    window.dispatchEvent(new Event("userLogout"));

    setAccountOpen(false);

    navigate("/");
  };
  /* ================= SEARCH ================= */

  const handleSearch = () => {
    if (!search.trim()) return;

    navigate(`/search?query=${search}&type=${category}`);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const shouldOpen = sessionStorage.getItem("openLoginPopup");

    if (shouldOpen === "true") {
      setShowLogin(true);
      sessionStorage.removeItem("openLoginPopup");
    }
  }, []);
  const isCreatorsActive =
    location.pathname === "/designer" || location.pathname === "/sketchers";
  const isBuyDesignsActive =
    location.pathname === "/designs" || location.pathname === "/Calculate";
  return (
    <>
      {/* ================= TOP HEADER ================= */}

      <div className="top-header">
        <div className="container-fluid header-container">
          {/* LOGO */}

          {/* <div className="logo">
            <img
              src="/logo.png"
              alt="Embroidery Bazar"
              style={{ height: "90px", objectFit: "contain" }}
              className="pe-2"
            />
            <span className="logo-dark">Embroidery</span>
            <span className="logo-light">Bazar</span>
          </div> */}
          <div
            className="logo"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/logo.png"
              alt="Embroidery Bazar"
              style={{ height: "90px", objectFit: "contain" }}
              className="pe-2"
            />
            <span className="logo-dark">Embroidery</span>
            <span className="logo-light">Bazar</span>
          </div>

          {/* SEARCH */}
          <div className="search-box">
            <div className="search-input-group">
              <select
                className="search-category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="all">All</option>
                <option value="designer">Creators</option>
                <option value="machine">Machines</option>
                <option value="workspace">Workspace</option>
              </select>

              <input
                type="text"
                className="main-search-input"
                placeholder="Search city, skill, machine..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
              />

              <button className="search-submit-btn" onClick={handleSearch}>
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>

          <div className="navbar-interaction-group">
            <Link to="/wishlist" className="nav-item-container">
              <i className="bi bi-heart"></i>
              {counts.wishlist > 0 && (
                <span className="status-indicator">{counts.wishlist}</span>
              )}
            </Link>

            <Link to="/cart" className="nav-item-container">
              <i className="bi bi-cart"></i>
              {counts.cart > 0 && (
                <span
                  className="status-indicator"
                  // style={{ fontWeight: "800" }}
                >
                  {counts.cart}
                </span>
              )}
            </Link>

            <Link
              to="/myorders"
              className="nav-item-container"
              title="My Orders"
            >
              <i className="bi bi-bag-check"></i>
              {counts.orders > 0 && (
                <span className="status-indicator status-green">
                  {counts.orders}
                </span>
              )}
            </Link>
          </div>

          <div className="account-section" ref={dropdownRef}>
            <div className="dropdown">
              <button
                className="account-btn"
                onClick={() => setAccountOpen(!accountOpen)}
              >
                <i className="bi bi-person"> </i>
                {user ? user.name : "My Account"}
              </button>

              <div className={`dropdown-menu ${accountOpen ? "show" : ""}`}>
                {user ? (
                  <>
                    <div className="dropdown-user">
                      <i className="bi bi-person-circle"></i>
                      <span>{user.name}</span>
                    </div>

                    <hr />

                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowprofile(true);
                        setAccountOpen(false);
                      }}
                    >
                      Profile
                    </Link>
                    <Link to="/Transaction-details">Transaction Details</Link>
                    {/* Show only if account_type = provider OR role = admin */}
                    {user &&
                      (user?.account_type === "provider" ||
                        user?.role === "admin") && (
                        <Link
                          to={user?.role === "admin" ? "/admin" : "/user"}
                          onClick={() => setAccountOpen(false)}
                          className="provider-panel-btn"
                        >
                          Go To Dashboard
                        </Link>
                      )}
                    {/* {user &&
                      (user?.account_type === "provider" ||
                        user?.role === "admin") && (
                        <Link
                          to={
                            user?.role === "admin"
                              ? "/Transaction-details"
                              : "/Transaction-details"
                          }
                          onClick={() => setAccountOpen(false)}
                          className="provider-panel-btn"
                        >
                          Transaction Details
                        </Link>
                      )} */}
                    <button
                      className="dropdown-item logout-btn"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowLogin(true);
                        setAccountOpen(false);
                      }}
                    >
                      Login
                    </Link>
                    <Link to="/register" state={{ from: location.pathname }}>
                      Sign Up
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}

      <div
        className={`main-navbar
  ${showStickyNav ? "sticky-navbar" : ""}
  ${hideNav ? "navbar-hide" : ""}`}
      >
        <div className="container-fluid nav-container">
          <div className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <i className="bi bi-list"></i>
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <Link
              to="/Home"
              className={location.pathname === "/Home" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>

            <Link
              to="/About"
              className={location.pathname === "/About" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              About us
            </Link>
            <Link
              to="/Work-list"
              className={
                location.pathname === "/Work-list" ? "active-link" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Bid Design Work
            </Link>
            {/* <Link
              to="/designs"
              className={location.pathname === "/designs" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Buy Designs
            </Link> */}
            <div className="supplier-menu">
              <Link
                to="#"
                className={`supplier-title ${isBuyDesignsActive ? "active-link" : ""}`}
                onClick={(e) => e.preventDefault()}
              >
                Buy Designs
                <i
                  className="bi bi-caret-down-fill"
                  style={{
                    fontSize: "12px",
                    padding: "3px",
                  }}
                ></i>
              </Link>

              <div className="supplier-dropdown">
                <Link
                  to="/designs"
                  state={{ activeTab: "free" }}
                  onClick={() => setMenuOpen(false)}
                >
                  Free Designs
                </Link>

                <Link
                  to="/designs"
                  state={{ activeTab: "paid" }}
                  onClick={() => setMenuOpen(false)}
                >
                  Paid Designs
                </Link>

                <Link to="/Calculate" onClick={() => setMenuOpen(false)}>
                  Calculate Cost
                </Link>
              </div>
            </div>
            <div className="supplier-menu">
              <Link
                to="#"
                className={`supplier-title ${isCreatorsActive ? "active-link" : ""}`}
                onClick={(e) => e.preventDefault()}
              >
                Creators
                <i
                  className="bi bi-caret-down-fill"
                  style={{
                    fontSize: "12px",
                    padding: "3px",
                  }}
                ></i>
              </Link>

              <div className="supplier-dropdown">
                <Link to="/designer" onClick={() => setMenuOpen(false)}>
                  Designers
                </Link>

                <Link to="/sketchers" onClick={() => setMenuOpen(false)}>
                  Sketchers
                </Link>
              </div>
            </div>
            {/* <Link
              to="/buy-designs"
              className={
                location.pathname === "/buy-designs" ? "active-link" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Sample Designes
            </Link> */}
            <Link
              to="/machine"
              className={location.pathname === "/machine" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Buy Machines
            </Link>

            <Link
              to="/house"
              className={location.pathname === "/house" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Rent Workspace
            </Link>
            {/* <Link
              to="/pay"
              className={location.pathname === "/pay" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Pay
            </Link> */}

            {/* <Link
              to="/designer"
              className={location.pathname === "/designer" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Designers
            </Link> */}

            {/* <Link
              to="/sketchers"
              className={
                location.pathname === "/sketchers" ? "active-link" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Sketchers
            </Link> */}
            {/* <div className="supplier-menu">
              <Link
                to="#"
                className="supplier-title"
                onClick={(e) => e.preventDefault()}
              >
                Suppliers <i className="bi bi-chevron-down"></i>
              </Link>

              <div className="supplier-dropdown">
                {supplierTypes.map((item) => (
                  <Link
                    key={item.id}
                    to={`/supplier/${item.type}`}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.display_name}
                  </Link>
                ))}
              </div>
            </div> */}
            <Link
              to="/supplier"
              className={location.pathname === "/supplier" ? "active-link" : ""}
            >
              Suppliers
            </Link>
            <Link
              to="/Hiring"
              className={location.pathname === "/Hiring" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Hire Designers
            </Link>

            <Link
              to="/Contact"
              className={location.pathname === "/Contact" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
            {/* <Link
              to="/Calculate"
              className={
                location.pathname === "/Calculate" ? "active-link" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Calculate
            </Link> */}

            {/* <div className="supplier-menu">
              <Link
                to="#"
                className="supplier-title"
                onClick={(e) => e.preventDefault()}
              >
                Other <i className="bi bi-chevron-down"></i>
              </Link>

              <div className="supplier-dropdown">
                <Link to="/Calculate" onClick={() => setMenuOpen(false)}>
                  Calculate
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {showStickyNav && (
        <div className="floating-actions">
          <Link
            to="/wishlist"
            className="floating-btn"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <i className="bi bi-heart"></i>
            {counts.wishlist > 0 && <span>{counts.wishlist}</span>}
          </Link>

          <Link
            to="/cart"
            className="floating-btn"
            data-aos="fade-left"
            data-aos-delay="150"
          >
            <i className="bi bi-cart"></i>
            {counts.cart > 0 && <span>{counts.cart}</span>}
          </Link>

          <Link
            to="/myorders"
            className="floating-btn"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <i className="bi bi-bag-check"></i>
            {counts.orders > 0 && <span>{counts.orders}</span>}
          </Link>
        </div>
      )}
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          title="Back to Top"
        >
          <i className="bi bi-arrow-up"></i>
        </button>
      )}
      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);

          navigate("/register", {
            state: { from: location.pathname },
          });
        }}
      />

      {showprofile && (
        <Profile isOpen={showprofile} onClose={() => setShowprofile(false)} />
      )}
    </>
  );
}
